{
  "COMPOSE_REDIRECT": {
    "OPENING": "A abrir uma nova conversa com {email}…",
    "NO_EMAIL": "Nenhum endereço de e-mail fornecido. Utilize ?email=name@example.com",
    "CONTACT_ERROR": "Não foi possível encontrar o contacto para {email}."
  },
  "CONVERSATION": {
    "SELECT_A_CONVERSATION": "Por favor, selecione uma conversa no painel da esquerda",
    "CSAT_REPLY_MESSAGE": "Por favor, avalie a conversa",
    "404": "Desculpe, não encontrámos a conversa. Por favor, tente novamente",
    "SWITCH_VIEW_LAYOUT": "Alternar o layout",
    "DASHBOARD_APP_TAB_MESSAGES": "Mensagens",
    "UNVERIFIED_SESSION": "A identidade deste utilizador não foi verificada",
    "NO_MESSAGE_1": "Não há mensagens de clientes na sua caixa de entrada.",
    "NO_MESSAGE_2": " para enviar uma mensagem para a sua página!",
    "NO_INBOX_1": "Ainda não adicionou nenhuma caixa de entrada.",
    "NO_INBOX_2": " para começar",
    "NO_INBOX_AGENT": "Não faz parte de nenhuma caixa de entrada. Por favor, contacte o administrador",
    "SEARCH_MESSAGES": "Procurar mensagens em conversas",
    "VIEW_ORIGINAL": "View original",
    "VIEW_TRANSLATED": "View translated",
    "TRANSLATION": "Tradução",
    "EMPTY_STATE": {
      "CMD_BAR": "para abrir o menu de comandos",
      "KEYBOARD_SHORTCUTS": "para ver atalhos de teclado"
    },
    "SEARCH": {
      "TITLE": "Procurar mensagens",
      "RESULT_TITLE": "Resultados da pesquisa",
      "LOADING_MESSAGE": "A preparar os dados...",
      "PLACEHOLDER": "Insira qualquer texto para procurar mensagens",
      "NO_MATCHING_RESULTS": "Nenhum resultado encontrado."
    },
    "UNREAD_MESSAGES": "Mensagens por ler",
    "UNREAD_MESSAGE": "Mensagens por ler",
    "CLICK_HERE": "Clique aqui",
    "LOADING_INBOXES": "A carregar caixas de entrada",
    "LOADING_CONVERSATIONS": "A carregar conversas",
    "CANNOT_REPLY": "Não pode responder porque",
    "24_HOURS_WINDOW": "Mensagens bloqueadas durante 24 horas",
    "NOT_ASSIGNED_TO_YOU": "Esta conversa não está atribuída a si. Gostaria de atribuir esta conversa a si mesmo?",
    "ASSIGN_TO_ME": "Atribuir a mim",
    "TWILIO_WHATSAPP_CAN_REPLY": "Só pode responder utilizando uma mensagem modelo, porque",
    "TWILIO_WHATSAPP_24_HOURS_WINDOW": "Mensagens bloqueadas durante 24 horas",
    "REPLYING_TO": "Está a responder a:",
    "REMOVE_SELECTION": "Remover seleção",
    "DOWNLOAD": "Descarregar",
    "UNKNOWN_FILE_TYPE": "Ficheiro desconhecido",
    "SAVE_CONTACT": "Save Contact",
    "NO_CONTENT": "No content to display",
    "COPILOT_ASSUMED_ACTIONS": {
      "TITLE": "Antes de enviar, realize:",
      "EXECUTE": "Executar",
      "RETRY": "Tentar novamente",
      "CONFIRM": "Executar agora?",
      "CONFIRM_YES": "Sim, executar",
      "CONFIRM_NO": "Cancelar",
      "RUNNING": "A executar…",
      "DONE": "Concluído",
      "CLAIM_DELAYED": "será registada quando a encomenda for entregue",
      "DEVIATIONS": {
        "CLAIM_CLOSED": "Foi criada uma NOVA reclamação {reference}, pois {planned} está encerrada — edite o texto do rascunho",
        "NEW_CLAIM": "Foi criada uma NOVA reclamação {reference} em vez de atualizar {planned} — edite o texto do rascunho",
        "OTHER_CLAIM": "Foi atualizada a reclamação {reference} em vez de {planned} — edite o texto do rascunho",
        "EXISTING_CLAIM": "Não foi criada nenhuma reclamação nova, foi atualizada a existente {reference} — edite o texto do rascunho",
        "OTHER": "Decorreu de forma diferente do que o rascunho previa — edite o texto do rascunho"
      },
      "FAILED": "Falhou",
      "UNREACHABLE": "Não foi possível contactar o bot",
      "REQUEST_FAILED": "Não foi possível iniciar a ação, tente novamente.",
      "ACTIONS": {
        "CANCEL_ORDER": "Cancelar a encomenda",
        "CHANGE_ORDER_PAYMENT_TO_COD": "Alterar o pagamento para contra-reembolso",
        "CREATE_CLAIM": "Apresentar uma reclamação",
        "CREATE_OR_UPDATE_CLAIM": "Apresentar ou atualizar uma reclamação",
        "EXTEND_ORDER_PICKUP_DATE": "Prolongar o prazo de levantamento"
      }
    },
    "SHARED_ATTACHMENT": {
      "CONTACT": "{sender} has shared a contact",
      "LOCATION": "{sender} has shared a location",
      "FILE": "{sender} has shared a file"
    },
    "UPLOADING_ATTACHMENTS": "A carregar anexos...",
    "REPLIED_TO_STORY": "Respondeu à sua história",
    "UNSUPPORTED_MESSAGE": "This message is unsupported. You can view this message on the Facebook / Instagram app.",
    "UNSUPPORTED_MESSAGE_FACEBOOK": "Esta mensagem não é suportada. Pode ver esta mensagem na app Facebook Messenger.",
    "UNSUPPORTED_MESSAGE_INSTAGRAM": "Esta mensagem não é suportada. Pode ver esta mensagem na app do Instagram.",
    "SUCCESS_DELETE_MESSAGE": "Mensagem apagada com sucesso",
    "FAIL_DELETE_MESSSAGE": "Não foi possível apagar a mensagem! Por favor, tente novamente",
    "NO_RESPONSE": "Sem resposta",
    "RESPONSE": "Response",
    "RATING_TITLE": "Avaliar",
    "FEEDBACK_TITLE": "Comentários",
    "REPLY_MESSAGE_NOT_FOUND": "Mensagem indisponível",
    "CARD": {
      "SHOW_LABELS": "Mostrar etiquetas",
      "HIDE_LABELS": "Ocultar etiquetas"
    },
    "HEADER": {
      "RESOLVE_ACTION": "Resolver",
      "REOPEN_ACTION": "Reabrir",
      "OPEN_ACTION": "Abertas",
      "OPEN": "Mais",
      "CLOSE": "Fechar",
      "DETAILS": "Detalhes",
      "SNOOZED_UNTIL": "Suspender até",
      "SNOOZED_UNTIL_TOMORROW": "Adiada até amanhã",
      "SNOOZED_UNTIL_NEXT_WEEK": "Adiada até a próxima semana",
      "SNOOZED_UNTIL_NEXT_REPLY": "Adiada até à próxima resposta",
      "SLA_STATUS": {
        "FRT": "FRT {status}",
        "NRT": "NRT {status}",
        "RT": "RT {status}",
        "MISSED": "missed",
        "DUE": "due"
      },
      "MORE": "More actions"
    },
    "RESOLVE_DROPDOWN": {
      "MARK_PENDING": "Marcar como pendente",
      "SNOOZE_UNTIL": "Adiar",
      "SNOOZE": {
        "TITLE": "Suspender até",
        "NEXT_REPLY": "Próxima resposta",
        "TOMORROW": "Amanhã",
        "NEXT_WEEK": "Próxima semana"
      },
      "RESOLVE_WITHOUT_CSAT": "Resolve without CSAT"
    },
    "CUSTOM_SNOOZE": {
      "TITLE": "Suspender até",
      "APPLY": "Adiar",
      "CANCEL": "Cancelar"
    },
    "PRIORITY": {
      "TITLE": "Prioridade",
      "OPTIONS": {
        "NONE": "Nenhuma",
        "URGENT": "Urgente",
        "HIGH": "Elevada",
        "MEDIUM": "Média",
        "LOW": "Baixa"
      },
      "CHANGE_PRIORITY": {
        "SELECT_PLACEHOLDER": "Nenhuma",
        "INPUT_PLACEHOLDER": "Selecione a prioridade",
        "NO_RESULTS": "Nenhum resultado encontrado",
        "SUCCESSFUL": "Alterar a prioridade da conversa com o id {conversationId} para {priority}",
        "FAILED": "Não foi possível alterar a prioridade, por favor, tente novamente."
      }
    },
    "CARD_CONTEXT_MENU": {
      "OPEN_IN_NEW_TAB": "Abrir num novo separador",
      "COPY_LINK": "Copiar link da conversa",
      "COPY_LINK_SUCCESS": "Link da conversa copiado para a área de transferência",
      "PENDING": "Marcar como pendente",
      "RESOLVED": "Marcar como resolvida",
      "MARK_AS_UNREAD": "Marcar como não lida",
      "MARK_AS_READ": "Marcar como lida",
      "REOPEN": "Reabrir conversa",
      "SNOOZE": {
        "TITLE": "Adiar",
        "NEXT_REPLY": "Até à próxima resposta",
        "TOMORROW": "Até amanhã",
        "NEXT_WEEK": "Até à próxima semana"
      },
      "ASSIGN_AGENT": "Atribuir agente",
      "ASSIGN_LABEL": "Atribuir etiqueta",
      "AGENTS_LOADING": "A carregar agentes...",
      "ASSIGN_TEAM": "Atribuir equipa",
      "API": {
        "AGENT_ASSIGNMENT": {
          "SUCCESFUL": "Conversa com ID {conversationId} atribuída a \"{agentName}\"",
          "FAILED": "Não foi possível atribuir agente. Por favor, tente novamente."
        },
        "LABEL_ASSIGNMENT": {
          "SUCCESFUL": "Assigned label #{labelName} to conversation id {conversationId}",
          "FAILED": "Não foi possível atribuir etiqueta. Por favor, tente novamente."
        },
        "TEAM_ASSIGNMENT": {
          "SUCCESFUL": "Equipa \"{team}\" atribuída  a conversa de ID {conversationId}",
          "FAILED": "Não foi possível atribuir equipa. Por favor, tente novamente."
        }
      }
    },
    "FOOTER": {
      "MESSAGE_SIGN_TOOLTIP": "Assinatura da mensagem",
      "ENABLE_SIGN_TOOLTIP": "Ativar assinatura",
      "DISABLE_SIGN_TOOLTIP": "Desativar assinatura",
      "MSG_INPUT": "Shift + Enter para nova linha. Comece com '/' para selecionar uma resposta pronta.",
      "PRIVATE_MSG_INPUT": "Shift + Enter para nova linha. Esta mensagem apenas será visível para agentes",
      "MESSAGE_SIGNATURE_NOT_CONFIGURED": "A assinatura da mensagem não está configurada. Por favor, configure-a nas configurações do perfil.",
      "CLICK_HERE": "Clique aqui para atualizar",
      "WHATSAPP_TEMPLATES": "Template do WhatsApp",
      "WHATSAPP_TEMPLATE_ONLY_INPUT": "A janela de 24 horas do WhatsApp expirou. Responda com um template.",
      "INSERT_SIGNATURE": "Insert signature into editor",
      "SIGNATURE_PREVIEW_IMAGE": "(image signature)"
    },
    "REPLYBOX": {
      "LANGUAGE_MISMATCH": "A sua resposta parece estar em {draftLanguage}, mas esta conversa está em {conversationLanguage}.",
      "TRANSLATE_DRAFT": "Traduzir",
      "REPLY": "Responder",
      "PRIVATE_NOTE": "Nota Privada",
      "SEND": "Enviar",
      "CREATE": "Adicionar nota",
      "INSERT_READ_MORE": "Ler mais",
      "DISMISS_REPLY": "Descartar resposta",
      "REPLYING_TO": "Em resposta a:",
      "TIP_FORMAT_ICON": "Mostrar editor de texto completo",
      "HEADING_LEVEL": {
        "LABEL": "Estilo de texto",
        "NORMAL": "Texto normal",
        "H1": "Título 1",
        "H2": "Título 2",
        "H3": "Título 3"
      },
      "EDITOR": {
        "BOLD": "Negrito",
        "ITALIC": "Itálico",
        "UNDERLINE": "Sublinhado",
        "TEXT_COLOR": "Cor do texto",
        "BG_COLOR_LABEL": "Cor de fundo",
        "FONT_SIZE_LABEL": "Tamanho da letra",
        "FONT_SIZE": {
          "XS": "Pequeno",
          "SM": "Médio pequeno",
          "MD": "Padrão",
          "LG": "Grande",
          "XL": "Muito grande",
          "XXL": "Enorme"
        },
        "CODE": "Código",
        "LINK": "Adicionar ou remover link",
        "CREATE_LINK": "Criar link",
        "SAVE_LINK": "Guardar",
        "CANCEL": "Cancelar",
        "LINK_PLACEHOLDER": "https://example.com",
        "UNDO": "Anular",
        "REDO": "Refazer",
        "BULLET_LIST": "Lista com marcadores",
        "ORDERED_LIST": "Lista numerada",
        "BLOCKQUOTE": "Citação",
        "H1": "Título 1",
        "H2": "Título 2",
        "H3": "Título 3",
        "IMAGE_UPLOAD": "Carregar imagem",
        "CLEAR_FORMATTING": "Limpar formatação",
        "COLOR": {
          "RED": "Vermelho",
          "YELLOW": "Amarelo",
          "BLUE": "Azul",
          "ROSE_RED": "Vermelho rosado",
          "DEEP_CYAN": "Ciano profundo",
          "ORANGE": "Laranja",
          "PISTACHIO": "Pistácio",
          "PURPLE": "Roxo",
          "FUCHSIA": "Fúchsia",
          "SILVER": "Prateado",
          "NAVY": "Azul-marinho",
          "OLD_PINK": "Rosa antigo",
          "AQUA": "Turquesa",
          "BROWN": "Castanho",
          "OLIVE": "Verde-oliva",
          "GOLD": "Dourado",
          "BEIGE": "Bege",
          "WINE": "Vinho",
          "FOREST": "Verde-floresta",
          "GREEN": "Verde",
          "BLUE_GREY": "Azul-acinzentado",
          "RUBY_RED": "Vermelho-rubi",
          "CHESTNUT_BROWN": "Castanha",
          "ASH_GREY": "Cinzento"
        },
        "BG_COLOR": {
          "RED": "Vermelho",
          "YELLOW": "Amarelo",
          "BLUE": "Azul",
          "ROSE_RED": "Vermelho rosado",
          "DEEP_CYAN": "Ciano profundo",
          "ORANGE": "Laranja",
          "PISTACHIO": "Pistácio",
          "PURPLE": "Roxo",
          "FUCHSIA": "Fúchsia",
          "SILVER": "Prateado",
          "NAVY": "Azul-marinho",
          "OLD_PINK": "Rosa antigo",
          "AQUA": "Turquesa",
          "BROWN": "Castanho",
          "OLIVE": "Verde-oliva",
          "GOLD": "Dourado",
          "BEIGE": "Bege",
          "WINE": "Vinho",
          "FOREST": "Verde-floresta",
          "GREEN": "Verde",
          "BLUE_GREY": "Azul-acinzentado",
          "RUBY_RED": "Vermelho-rubi",
          "CHESTNUT_BROWN": "Castanha",
          "ASH_GREY": "Cinzento"
        }
      },
      "TIP_EMOJI_ICON": "Mostrar selecionador de emojis",
      "TIP_ATTACH_ICON": "Anexar ficheiros",
      "TIP_AUDIORECORDER_ICON": "Gravar áudio",
      "TIP_AUDIORECORDER_PERMISSION": "Permitir acesso ao áudio",
      "TIP_AUDIORECORDER_ERROR": "Não foi possível abrir o áudio",
      "DRAG_DROP": "Arrastar e soltar aqui para anexar",
      "START_AUDIO_RECORDING": "Iniciar gravação de áudio",
      "STOP_AUDIO_RECORDING": "Parar gravação de áudio",
      "": "",
      "EMAIL_HEAD": {
        "TO": "PARA",
        "ADD_BCC": "Adicionar Bcc",
        "CC": {
          "LABEL": "Cc",
          "PLACEHOLDER": "E-mails separados por vírgulas",
          "ERROR": "Por favor, insira endereços de e-mail válidos"
        },
        "BCC": {
          "LABEL": "Bcc",
          "PLACEHOLDER": "E-mails separados por vírgulas",
          "ERROR": "Por favor, insira endereços de e-mail válidos"
        },
        "EDIT": "Edit",
        "EXPAND": "Cc/Bcc",
        "HIDE": "Hide",
        "INCLUDE_ORIGINAL_MESSAGE": "Include original message",
        "EDIT_HEADERS": "Edit",
        "HIDE_HEADER_EDITS": "Hide edits",
        "SUBJECT": {
          "LABEL": "SUBJECT",
          "PLACEHOLDER": "Email subject",
          "RE_PREFIX": "Re:"
        }
      },
      "UNDEFINED_VARIABLES": {
        "TITLE": "Variáveis indefinidas",
        "MESSAGE": "Tem {undefinedVariablesCount} variáveis indefinidas na sua mensagem: {undefinedVariables}. Pretende enviar a mensagem mesmo assim?",
        "CONFIRM": {
          "YES": "Enviar",
          "CANCEL": "Cancelar"
        }
      },
      "SEND_EMAIL": "Send email",
      "SEND_SMS": "Send SMS",
      "NO_SMS_INBOX": "Adicione uma caixa de entrada de SMS para enviar respostas por SMS.",
      "SEND_CHAT": "Send chat",
      "REPLY_TO_THIS": "Reply to this",
      "TIP_EXPAND_ICON": "Enlarge editor",
      "TIP_COLLAPSE_ICON": "Shrink editor",
      "COPILOT": {
        "Q": "Ask robot for help"
      }
    },
    "VISIBLE_TO_AGENTS": "Nota Privada: Apenas visível para si e para a sua equipa",
    "CHANGE_STATUS": "Estado da conversa alterado",
    "CHANGE_STATUS_FAILED": "A mudança de estado da conversa falhou",
    "CHANGE_AGENT": "Responsável da conversa alterado",
    "CHANGE_AGENT_FAILED": "Falha na alteração da atribuição",
    "ASSIGN_LABEL_SUCCESFUL": "Etiqueta atribuída com sucesso",
    "ASSIGN_LABEL_FAILED": "Falha na atribuição de etiqueta",
    "CHANGE_TEAM": "Equipa da conversa alterada",
    "FILE_SIZE_LIMIT": "O ficheiro excede o tamanho limite para anexos de {MAXIMUM_SUPPORTED_FILE_UPLOAD_SIZE} MB",
    "MESSAGE_ERROR": "Não foi possível enviar esta mensagem, por favor, tente novamente mais tarde",
    "SENT_BY": "Enviado por:",
    "BOT": "Bot",
    "SEND_FAILED": "Não foi possível enviar a mensagem! Tente novamente",
    "TRY_AGAIN": "Tentar novamente",
    "ASSIGNMENT": {
      "SELECT_AGENT": "Escolher agente",
      "REMOVE": "Excluir",
      "ASSIGN": "Atribuir"
    },
    "CONTEXT_MENU": {
      "COPY": "Copiar",
      "REPLY_TO": "Responder a esta mensagem",
      "DELETE": "Excluir",
      "CREATE_A_CANNED_RESPONSE": "Adicionar às respostas prontas",
      "TRANSLATE": "Traduzir",
      "COPY_PERMALINK": "Copiar link para a mensagem",
      "LINK_COPIED": "URL da mensagem copiado para a área de transferência",
      "DELETE_CONFIRMATION": {
        "TITLE": "Tem a certeza que pretende apagar esta mensagem?",
        "MESSAGE": "Esta ação é irreversível",
        "DELETE": "Excluir",
        "CANCEL": "Cancelar"
      },
      "FORWARD": "Foward",
      "FORWARD_ERROR": "Failed to prepare forwarded message"
    },
    "SIDEBAR": {
      "CONTACT": "Contacto",
      "COPILOT": "Copilot"
    },
    "MESSAGE_EVENT": {
      "ACTIVITY": {
        "STATUS": {
          "RESOLVED": "Conversa foi marcada como resolvida por {userName}",
          "CONTACT_RESOLVED": "Conversa foi resolvida por {contactName}",
          "OPEN": "Conversa foi reaberta por {userName}",
          "PENDING": "Conversa marcada como pendente por {userName}",
          "SNOOZED": "Conversa adiada por {userName}",
          "AUTO_RESOLVED": "Conversa auto-resolvida pelo sistema por causa dos {duration} dias sem inatividade",
          "SYSTEM_AUTO_OPEN": "O sistema reabriu a conversa por ter sido recebida uma nova mensagem.",
          "AUTO_REOPENED": "System reopened the conversation after the snooze period ended.",
          "RESOLVED_WITHOUT_CSAT": "Conversation was marked resolved by {userName} (without CSAT)",
          "AUTO_RESOLVED_INACTIVE": "Conversation was marked resolved by system due to {duration} hours of inactivity",
          "AUTO_RESOLVED_EMPTY": "Conversation was marked resolved by system due to being empty.",
          "BLOCKED_CONTACT_RESOLVED": "System resolved the conversation because the contact is blocked.",
          "KAUFLAND_TICKET_CLOSED": "O sistema resolveu a conversa porque o ticket foi fechado no Kaufland."
        },
        "PRIORITY": {
          "ADDED": "{userName} definiu a prioridade para {newPriority}",
          "UPDATED": "{userName} mudou a prioridade de {oldPriority} para {newPriority}",
          "REMOVED": "{userName} removeu a prioridade"
        },
        "ASSIGNEE": {
          "SELF_ASSIGNED": "{userName} auto-atribuída esta conversa",
          "ASSIGNED": "Atribuído a {assigneeName} por {userName}",
          "REMOVED": "Conversa não atribuída por {userName}"
        },
        "TEAM": {
          "ASSIGNED": "Atribuído a {teamName} por {userName}",
          "ASSIGNED_WITH_ASSIGNEE": "Atribuído a {assigneeName} via {teamName} por {userName}",
          "REMOVED": "Não atribuído a {teamName} por {userName}"
        },
        "LABELS": {
          "ADDED": "{userName} acrescentou {labels}",
          "REMOVED": "{userName} removeu a {labels}"
        },
        "SLA": {
          "ADDED": "{userName} adicionou uma política de SLA {slaName}",
          "REMOVED": "{userName} removeu a política de SLA de {slaName}",
          "UPDATED": "{userName} updated SLA policy {slaName}"
        },
        "MUTED": "{userName} bloqueou a conversa",
        "UNMUTED": "{userName} reativou a conversa",
        "CONTACT_BLOCKED": "{userName} bloqueou o contacto",
        "CONTACT_UNBLOCKED": "{userName} desbloqueou o contacto",
        "AUTO_RESOLUTION_MESSAGE": "Resolving the conversation as it has been inactive for a while. Please start a new conversation if you need further assistance.",
        "DOMAIN_BLOCKED": "{userName} blocked all contacts for a given domain",
        "DOMAIN_UNBLOCKED": "{userName} unblocked all the contacts for a given domain",
        "MOVED": "{userName} moved this conversation from inbox {sourceInboxName} to inbox {targetInboxName}",
        "MOVED_BY_ORDER": "Movida porque as encomendas do contacto vêm apenas da loja {storeName} (última encomenda {orderId}), cujo robô responde nesta caixa de entrada.",
        "MERGED": "{userName} merged conversation #{sourceId} into this conversation",
        "AUTOMATION_RULE_TRIGGERED": "Automation rule \"{ruleName}\" triggered",
        "AUTOMATION_SKIP_AUTO_PRIORITY": "Automation rule \"{ruleName}\" disabled automatic priority",
        "AUTOMATION_SKIP_AUTO_LABELING": "Automation rule \"{ruleName}\" disabled automatic labeling",
        "AUTOMATION_STOP_PROCESSING_RULES": "Automation rule \"{ruleName}\" stopped further rule processing",
        "AUTOMATION_ACTION_SKIPPED_AUTO_REPLY": "Sending message action was skipped for this auto-reply message",
        "AUTOMATION_SKIPPED_CONTACT_BLOCKED": "A automação foi ignorada porque o contacto está bloqueado",
        "AUTOMATION_MOVE_FAILED_INCOMPATIBLE_INBOX": "A automatização \"{ruleName}\" não conseguiu mover esta conversa da caixa de entrada {sourceInboxName} para a caixa de entrada {targetInboxName} porque as caixas de entrada não são compatíveis.",
        "AUTOMATION_MOVE_FAILED_CONTACT_EMAIL_MISSING": "A automatização \"{ruleName}\" não conseguiu mover esta conversa da caixa de entrada {sourceInboxName} para a caixa de entrada {targetInboxName} porque o contacto não tem endereço de e-mail.",
        "AUTOMATION_RULE_DISABLED_PHONE_WITHOUT_SMS": "A automatização \"{ruleName}\" não conseguiu enviar uma mensagem: esta caixa de entrada telefónica não pode enviar SMS porque a conta não tem nenhuma caixa de entrada SMS. A regra foi desativada e os administradores receberam um e-mail.",
        "AUTOMATION_RULE_DISABLED_SMS_ATTACHMENTS_NOT_SUPPORTED": "A automatização \"{ruleName}\" não conseguiu enviar uma mensagem: não é possível enviar anexos por SMS a partir desta caixa de entrada. A regra foi desativada e os administradores receberam um e-mail.",
        "MACRO_ACTION_SKIPPED_PHONE_WITHOUT_SMS": "A macro \"{macroName}\" não enviou a sua mensagem: esta caixa de entrada telefónica não pode enviar SMS porque a conta não tem nenhuma caixa de entrada SMS.",
        "MACRO_ACTION_SKIPPED_SMS_ATTACHMENTS_NOT_SUPPORTED": "A macro \"{macroName}\" não enviou a sua mensagem: não é possível enviar anexos por SMS a partir desta caixa de entrada.",
        "MACRO_ACTION_SKIPPED_PENDING_WITH_BOT": "A macro \"{macroName}\" não enviou a sua mensagem: o bot está a tratar desta conversa. Abra primeiro a conversa.",
        "MACRO_ACTION_SKIPPED_INBOX_DELETE_REQUESTED": "A macro \"{macroName}\" não enviou a sua mensagem: esta caixa de entrada está marcada para exclusão. Mova primeiro a conversa para outra caixa de entrada.",
        "AUTOMATION_NEW_CONVERSATION_SENT": "A automatização \"{ruleName}\" enviou um e-mail para {contactEmail} numa nova conversa [#{conversationId}]({conversationPath}) na caixa de entrada {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_SOURCE": "A automatização \"{ruleName}\" iniciou esta conversa por causa da conversa [#{conversationId}]({conversationPath}) na caixa de entrada {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_FAILED_CONTACT_EMAIL_MISSING": "A automatização \"{ruleName}\" não conseguiu enviar a mensagem numa nova conversa na caixa de entrada {inboxName} porque o contacto não tem endereço de e-mail.",
        "AUTOMATION_NEW_CONVERSATION_SMS_SENT": "A automatização \"{ruleName}\" enviou um SMS para {contactPhone} numa nova conversa [#{conversationId}]({conversationPath}) na caixa de entrada {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_FAILED_CONTACT_PHONE_MISSING": "A automatização \"{ruleName}\" não conseguiu enviar o SMS numa nova conversa na caixa de entrada {inboxName} porque o contacto não tem número de telefone.",
        "AUTO_LABELING": {
          "REASONING": "Applied labels: {labels}\n{justification}"
        },
        "AUTO_PRIORITY": {
          "REASONING": "Updated priority: {reasoning}"
        },
        "SUMMARY": {
          "ROLE": {
            "AGENT": "Agente",
            "CUSTOMER": "Cliente"
          }
        }
      },
      "VOICE": {
        "COPILOT": {
          "CALLED_EXTENSIONS": "Called extensions:",
          "CALL_COMPLETED": "Call completed",
          "EXTENSION_OUTCOMES": {
            "ANSWERED_ELSEWHERE": "atendida noutro telefone, tocou durante {duration}",
            "NO_ANSWER": "sem resposta, tocou durante {duration}",
            "REJECTED": "rejeitada após tocar durante {duration}"
          },
          "EXTENSION_TYPES": {
            "IVR": "IVR",
            "OPERATOR": "Operator",
            "QUEUE": "Queue",
            "RING_GROUP": "Ring Group"
          },
          "INBOUND_CALL": "Inbound call from {number} to {did}",
          "IVR_HANDLED": "Handled by IVR",
          "IVR_LABEL_NOT_FOUND": "I wanted to add label {name}, but it does not exist, please check the configuration.",
          "CALL_MISSED": "Call missed",
          "CALL_NO_ANSWER": "No answer",
          "RESOLVED_AFTER_FAILED_CALLBACKS": "Resolvida automaticamente após {count} retornos de chamada sem sucesso",
          "OUTBOUND_CALL": "Outbound call made by {agentName} from {did} to {number}",
          "SUMMARY_NOT_AVAILABLE": "Unable to generate summary.",
          "RECORDING_DELETED": "Gravação da chamada eliminada por {name}, {date}"
        }
      }
    },
    "IMAGE_RESIZE": {
      "SMALL": "Small",
      "MEDIUM": "Medium",
      "LARGE": "Large",
      "ORIGINAL": "Original"
    },
    "SHOW_HIDDEN_MESSAGES": "Show hidden messages",
    "TRANSCRIPT": {
      "SHOW": "Show full transcript",
      "HIDE": "Hide full transcript",
      "DOWNLOAD": "Download transcript",
      "COPY": "Copy transcript"
    },
    "INVISIBLE_TO_CUSTOMER": "Invisível para o cliente",
    "SENT_VIA_EMAIL": "Também enviado ao contacto por e-mail ({time})",
    "API_HOURS_WINDOW": "You can only reply to this conversation within {hours} hours",
    "FACEBOOK_CANNOT_REPLY": "If you need to continue this conversation, ",
    "PENDING_WITH_BOT_BANNER": "This conversation is being handled by AI bot. If you want to reply, open the conversation first.",
    "INBOX_DELETE_REQUESTED_BANNER": "Esta caixa de entrada está marcada para exclusão, por isso a resposta do cliente nunca chegaria. Mova a conversa para outra caixa de entrada para responder.",
    "OPEN_CONVERSATIONS_BANNER": {
      "SINGLE": "Este contacto tem outra conversa aberta #{id}",
      "MULTIPLE": "Este contacto tem outras conversas abertas ({count})",
      "OPEN": "Abrir",
      "SHOW": "Mostrar"
    },
    "OLD_INSTAGRAM_INBOX_REPLY_BANNER": "This Instagram account was migrated to the new Instagram channel inbox. All new messages will show up there. You won't be able to send messages from this conversation anymore.",
    "WEB_WIDGET_OFFLINE_MESSAGE": "Cannot send message because the customer is not online and email continuity is not available.",
    "WEB_WIDGET_OFFLINE_WARNING_MESSAGE": "The customer is not online. They may not receive messages since email continuity is not available.",
    "OPEN_FILE": "Open",
    "DOWNLOAD_ATTACHMENTS": "Download all",
    "DOWNLOAD_ATTACHMENTS_TOOLTIP": "Download all attachments one by one",
    "DOWNLOAD_ATTACHMENTS_AS_ZIP": "Download all as ZIP",
    "ERROR_DOWNLOADING_FILE": "Error downloading file",
    "REQUEST_CONTACT_INFO": {
      "ACTION": "Pedir ao cliente para partilhar o número de telefone do WhatsApp",
      "PENDING_ACTION": "Pedido de informação de contacto pendente",
      "STATES": {
        "PENDING": "A aguardar informação de contacto",
        "SHARED": "Número de telefone partilhado",
        "IDENTITY_CONFLICT": "Número de telefone precisa de revisão"
      }
    },
    "SLA": {
      "BREACHED": "breached"
    },
    "IMAGE_UPLOAD_ERROR": "Unable to upload image, please try again",
    "DRAFT": {
      "FILE_TOO_LARGE": "File '{fileName}' ({fileSize}) is too large for draft storage and will be skipped",
      "ATTACHMENT_SERIALIZATION_FAILED": "Failed to serialize attachment for draft storage",
      "STORAGE_QUOTA_EXCEEDED": "Storage quota exceeded. Draft saved without attachments",
      "SAVE_FAILED_WITHOUT_ATTACHMENTS": "Failed to save draft even without attachments",
      "SAVE_FAILED": "Failed to save conversation draft"
    },
    "COMMENT_TREE": {
      "TITLE": "Comment thread",
      "EMPTY": "No comments to display",
      "VIEW_TREE": "View comment thread"
    }
  },
  "EMAIL_TRANSCRIPT": {
    "TITLE": "Enviar transcrição da conversa",
    "DESC": "Envia uma cópia da transcrição da conversa para o endereço de e-mail especificado",
    "SUBMIT": "Submeter",
    "CANCEL": "Cancelar",
    "SEND_EMAIL_SUCCESS": "A transcrição da conversa foi enviada com sucesso",
    "SEND_EMAIL_ERROR": "Ocorreu um erro, por favor, tente novamente",
    "FORM": {
      "SEND_TO_CONTACT": "Enviar a transcrição ao cliente",
      "SEND_TO_AGENT": "Enviar a transcrição para o agente atribuído",
      "SEND_TO_OTHER_EMAIL_ADDRESS": "Enviar a transcrição para outro endereço de e-mail",
      "EMAIL": {
        "PLACEHOLDER": "Insira um endereço de e-mail",
        "ERROR": "Por favor, insira um endereço de e-mail válido"
      }
    }
  },
  "ONBOARDING": {
    "TITLE": "Olá 👋. Bem-vindo ao {installationName}!",
    "DESCRIPTION": "Obrigado por se registar. Queremos que aproveite ao máximo o sistema {installationName}. Aqui estão algumas coisas que pode fazer no {installationName} para tornar a sua experiência ainda mais agradável.",
    "GREETING_MORNING": "👋 Bom dia, {name}. Bem-vindo ao {installationName}.",
    "GREETING_AFTERNOON": "👋 Boa tarde, {name}. Bem-vindo ao {installationName}.",
    "GREETING_EVENING": "👋 Boa noite, {name}. Bem-vindo ao {installationName}.",
    "READ_LATEST_UPDATES": "Ler as últimas atualizações",
    "ALL_CONVERSATION": {
      "TITLE": "Todas as suas conversas num único lugar",
      "DESCRIPTION": "Ver todas as conversas dos seus clientes num único painel. Pode filtrar as conversas pelo canal de entrada, etiquetas e estado.",
      "NEW_LINK": "Clique aqui para criar uma caixa de entrada"
    },
    "TEAM_MEMBERS": {
      "TITLE": "Convidar os membros da sua equipa",
      "DESCRIPTION": "Já que se prepara para começar a conversar com o seu cliente, convide também os seus colegas para o ajudar. Pode adicionar colegas de equipa acrescentando os seus endereços de e-mail à lista de agentes.",
      "NEW_LINK": "Clique aqui para convidar um membro para a equipa"
    },
    "LABELS": {
      "TITLE": "Organizar conversas com etiquetas",
      "DESCRIPTION": "As etiquetas permitem-lhe categorizar facilmente as suas conversas. Crie etiquetas como #suporte, #faturacao, etc., para que as possa utilizar, mais tarde, numa conversa.",
      "NEW_LINK": "Clique aqui para criar etiquetas"
    },
    "CANNED_RESPONSES": {
      "TITLE": "Criar respostas prontas",
      "DESCRIPTION": "Os modelos de resposta rápida pré-escritos ajudam-no a responder rapidamente a uma conversa. Os agentes podem inserir o caractere '/' seguido do código curto para inserir uma resposta.",
      "NEW_LINK": "Clique aqui para criar uma resposta pronta"
    }
  },
  "CONVERSATION_SIDEBAR": {
    "ASSIGNEE_LABEL": "Agente atribuído",
    "SELF_ASSIGN": "Atribuir a mim",
    "TEAM_LABEL": "Equipa atribuída",
    "SELECT": {
      "PLACEHOLDER": "Nenhuma"
    },
    "ACCORDION": {
      "CUSTOM_DATA_PROVIDER": "Custom Data",
      "CONTACT_DETAILS": "Detalhes do contacto",
      "CONVERSATION_ACTIONS": "Ações de conversa",
      "CONVERSATION_LABELS": "Etiquetas da conversa",
      "CONVERSATION_INFO": "Informação da conversa",
      "CONTACT_ATTRIBUTES": "Atributos do contacto",
      "PREVIOUS_CONVERSATION": "Conversas anteriores",
      "MACROS": "Macros",
      "SHOPIFY_ORDERS": "Shopify Orders",
      "ORDER_HISTORY": "Order History",
      "RETINO_TICKETS": "Retino Tickets"
    },
    "SHOPIFY": {
      "ORDER_ID": "Order #{id}",
      "ERROR": "Error loading orders",
      "NO_SHOPIFY_ORDERS": "No orders found",
      "FINANCIAL_STATUS": {
        "PENDING": "Pendente",
        "AUTHORIZED": "Authorized",
        "PARTIALLY_PAID": "Partially Paid",
        "PAID": "Paid",
        "PARTIALLY_REFUNDED": "Partially Refunded",
        "REFUNDED": "Refunded",
        "VOIDED": "Voided"
      },
      "FULFILLMENT_STATUS": {
        "FULFILLED": "Fulfilled",
        "PARTIALLY_FULFILLED": "Partially Fulfilled",
        "UNFULFILLED": "Unfulfilled"
      }
    }
  },
  "CONVERSATION_CUSTOM_ATTRIBUTES": {
    "ADD_BUTTON_TEXT": "Criar atributo",
    "NO_RECORDS_FOUND": "Nenhum atributo encontrado",
    "UPDATE": {
      "SUCCESS": "Atributo atualizado com sucesso",
      "ERROR": "Não foi possível atualizar o atributo. Por favor, tente mais tarde"
    },
    "ADD": {
      "TITLE": "Adicionar",
      "SUCCESS": "Atributo adicionado com sucesso",
      "ERROR": "Não foi possível adicionar o atributo. Por favor, tente mais tarde"
    },
    "DELETE": {
      "SUCCESS": "Atributo apagado com sucesso",
      "ERROR": "Não foi possível apagar o atributo. Por favor, tente mais tarde"
    },
    "ATTRIBUTE_SELECT": {
      "TITLE": "Adicionar atributos",
      "PLACEHOLDER": "Pesquisar atributos",
      "NO_RESULT": "Nenhum atributo encontrado"
    }
  },
  "EMAIL_HEADER": {
    "FROM": "De",
    "TO": "Para",
    "BCC": "Bcc",
    "CC": "Cc",
    "SUBJECT": "Assunto"
  },
  "CONVERSATION_PARTICIPANTS": {
    "SIDEBAR_MENU_TITLE": "A participar",
    "SIDEBAR_TITLE": "Participantes da conversa",
    "NO_RECORDS_FOUND": "Nenhum resultado encontrado",
    "ADD_PARTICIPANTS": "Selecionar participantes",
    "REMANING_PARTICIPANTS_TEXT": "+{count} outros",
    "REMANING_PARTICIPANT_TEXT": "+{count} outro",
    "TOTAL_PARTICIPANTS_TEXT": "{count} pessoas estão a participar.",
    "TOTAL_PARTICIPANT_TEXT": "{count} pessoa está a participar.",
    "NO_PARTICIPANTS_TEXT": "Ninguém está a participar!",
    "WATCH_CONVERSATION": "Junte-se à conversa",
    "YOU_ARE_WATCHING": "Está a participar",
    "API": {
      "ERROR_MESSAGE": "Não foi possível atualizar, por favor, tente novamente!",
      "SUCCESS_MESSAGE": "Participantes atualizados!"
    },
    "SEARCH_PLACEHOLDER": "Search"
  },
  "TRANSLATE_MODAL": {
    "TITLE": "Ver conteúdo traduzido",
    "DESC": "Pode visualizar o conteúdo traduzido em cada linguagem.",
    "ORIGINAL_CONTENT": "Conteúdo original",
    "TRANSLATED_CONTENT": "Conteúdo traduzido",
    "NO_TRANSLATIONS_AVAILABLE": "Nenhuma tradução está disponível para este conteúdo"
  },
  "TYPING": {
    "ONE": "{user} is typing",
    "TWO": "{user} and {secondUser} are typing",
    "MULTIPLE": "{user} and {count} others are typing",
    "IMAGE_ALT": "Someone is typing"
  },
  "COPILOT": {
    "TRY_THESE_PROMPTS": "Try these prompts"
  },
  "GALLERY_VIEW": {
    "ERROR_DOWNLOADING": "Unable to download attachment. Please try again"
  },
  "CONVERSATION_CUSTOM_DATA_PROVIDER": {
    "NO_RECORDS_FOUND": "No data found",
    "LOAD_ERROR": "Unable to load data. Please try again later."
  },
  "CONVERSATION_RETINO_TICKETS": {
    "LOAD_MORE": "Load more",
    "NO_RECORDS_FOUND": "No tickets found",
    "LOAD_ERROR": "Unable to load tickets from {hookName}. Please try again later.",
    "NOT_SEARCHABLE": "Contact email is not set.",
    "TIMES": "&times;"
  },
  "CONVERSATION_ORDER_HISTORY": {
    "LOADING": "Loading...",
    "NO_ORDERS": "No orders found",
    "NOT_AVAILABLE": "Customer data not available",
    "EXPAND": "Open customer profile",
    "MORE_ITEMS": "+ {count} items",
    "EXPEDITION_STATUS": "Expedition status",
    "OPEN_DETAIL": "open detail",
    "COPY_ORDER_ID": "Número da encomenda",
    "EXTERNAL_ID": "ID externo",
    "PAYMENT_TYPE": "Método de pagamento",
    "PAYMENT_DATE": "Data de pagamento",
    "DELIVERY_PROVIDER": "Transportadora",
    "EXPECTED_DATE_OF_DELIVERY": "Entrega prevista",
    "DATE_OF_DELIVERY": "Entregue em",
    "EXPEDITION_DATE": "Data de expedição",
    "INTERNAL_NOTE": "Nota da loja",
    "PACKAGE_NUMBER": "Encomenda"
  },
  "READING": {
    "ONE": "{user} is reading this ticket",
    "TWO": "{user} and {secondUser} are reading this ticket",
    "MULTIPLE": "{user} and {count} others are reading this ticket"
  },
  "MOVE_CONVERSATION": {
    "TITLE": "Move Conversation",
    "DESCRIPTION": "Move this conversation to a different email inbox.",
    "SOURCE": {
      "TITLE": "Conversation",
      "ID_LABEL": "Conversation ID"
    },
    "TARGET": {
      "TITLE": "Destination Inbox",
      "PLACEHOLDER": "Select an email inbox",
      "NO_RESULTS": "No other email inboxes available",
      "ERROR": "Please select a destination inbox"
    },
    "SUBMIT": "Move Conversation",
    "CANCEL": "Cancel",
    "SUCCESS_MESSAGE": "Conversation moved successfully",
    "ERROR_MESSAGE": "Could not move conversation. Please try again."
  },
  "MERGE": {
    "TITLE": "Merge Conversations",
    "DESCRIPTION": "Merge this conversation with another conversation. All messages from this conversation will be moved to the target conversation, and this conversation will be deleted.",
    "SOURCE": {
      "TITLE": "Source Conversation (will be deleted)",
      "ID_LABEL": "Conversation ID"
    },
    "TARGET": {
      "TITLE": "Target Conversation",
      "PLACEHOLDER": "Type conversation ID to search (e.g., 123)",
      "HELP": "Enter the conversation ID to merge all messages into.",
      "ERROR": "Please select a target conversation"
    },
    "WARNING": "Warning: This action cannot be undone. All messages will be moved to the target conversation and this conversation will be permanently deleted.",
    "SUBMIT": "Merge Conversations",
    "CANCEL": "Cancel",
    "SUCCESS_MESSAGE": "Conversation merged successfully",
    "ERROR_MESSAGE": "Could not merge conversations. Please check the target conversation and try again.",
    "SEARCH": {
      "NO_RESULTS": "No conversation found with this ID",
      "ERROR_MESSAGE": "Could not search conversations. Please try again."
    },
    "CONFIRM": {
      "TITLE": "Confirm Merge",
      "DESCRIPTION": "Are you sure you want to merge this conversation? This action cannot be undone.",
      "YES": "Yes, Merge",
      "CANCEL": "Cancel"
    }
  }
}
